import React from 'react';
import { Dropdown, Button, Menu, message } from 'antd';
import { ExportOutlined, PrinterOutlined } from '@ant-design/icons';

import { PrintOpService } from '../Services/PrintOpService';

const ExportOrdrepaie = ({ numpiece , mode_paiement}) => {
 
  const handleMenuSelection = (e) => {
    const option = e.key;
    const hideMessage = message.loading("Impression en cours...", 0);
    if (option === "Ordre_Paiement" ||option==="Ordre_Virement_DIVERS" || option === "Lettre_Cheque_DIVERS") {
      PrintOpService(numpiece, option);
      hideMessage(); // Masquer le message de chargement après la réussite
      message.success("Impression réussie!");
    } else {
      console.error('Option non prise en charge:', option);
    }
  };

  const menu = (
    <Menu onClick={handleMenuSelection}>
      <Menu.Item key="Ordre_Paiement">Ordre De Paiement</Menu.Item>
      {mode_paiement ==='V' &&
      <Menu.Item key="Ordre_Virement_DIVERS">Ordre De Virement</Menu.Item>
      }
      {mode_paiement ==='C' &&
      <Menu.Item key="Lettre_Cheque_DIVERS">Lettre Cheque</Menu.Item>
    }
    </Menu>
  );

  return (
    <Dropdown overlay={menu} placement="bottomCenter">
       <PrinterOutlined  size="small" style={{ cursor: 'pointer', color: '#67f02e', marginRight: 8 }}  />
    </Dropdown>
  );
};

export default ExportOrdrepaie;
